'use client'

import { Skeleton } from '@/components/skeleton'
import { InteractiveCitiesSearchListContainer } from '@/features/cities/cities-finder/interactive-cities-search-list-container'

export const InteractiveCitiesSearchSkeleton = () => {
    return (
        <InteractiveCitiesSearchListContainer>
            <Skeleton className="h-[90px] w-full" />
            <div className="mt-10 md:mt-20" />
            <Skeleton className="h-[54px] rounded-full" />
            <div className="mt-10 md:mt-20" />
            <Skeleton className="h-[54px] w-full rounded-s" />
            <div className="mt-2" />
            <Skeleton className="h-[54px] w-full rounded-s" />
            <div className="mt-2" />
            <Skeleton className="h-[54px] w-full rounded-s" />
            <div className="mt-2" />
            <Skeleton className="h-[54px] w-full rounded-s" />
            <div className="mt-2" />
            <Skeleton className="h-[54px] w-full rounded-s" />
            <div className="mt-2" />
            <Skeleton className="h-[54px] w-full rounded-s" />
            <div className="mt-2" />
            <Skeleton className="h-[54px] w-full rounded-s" />
            <div className="mt-2" />
            <Skeleton className="h-[54px] w-full rounded-s" />
            <div className="mt-2" />
            <Skeleton className="h-[54px] w-full rounded-s" />
            <div className="mt-2" />
            <Skeleton className="h-[54px] w-full rounded-s" />
            <div className="mt-2" />
            <Skeleton className="h-[54px] w-full rounded-s" />
            <div className="mt-2" />
            <Skeleton className="h-[54px] w-full rounded-s" />
            <div className="mt-2" />
            <Skeleton className="h-[54px] w-full rounded-s" />
        </InteractiveCitiesSearchListContainer>
    )
}
